import React from "react";
import Button from "@atlaskit/button/new";

interface Props {
    btnTitle: string;
    onClick: Function;
    isLoading?: boolean;
}

export const SaveButton = (props: Props) => {

    function handleClick(event: React.MouseEvent<HTMLElement>) {
        event.currentTarget.focus();
        setTimeout(props.onClick, 0);
    }

    return (
        <Button onClick={handleClick} appearance={"primary"} isLoading={props.isLoading ?? false}>{props.btnTitle}</Button>
    );
}
